import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';
import { Profile } from 'src/app/shared/models/register.models';

@Component({
  selector: 'app-money-out-categorize',
  templateUrl: './money-out-categorize.component.html',
  styleUrls: ['./money-out-categorize.component.scss'],
})
export class MoneyOutCategorizeComponent implements OnInit {

  @Input() user: any;
  @Input() isMoneyIn: boolean = false;
  @Input() walletStatus: number;
  @Output() public continueEvent = new EventEmitter<any>();

  loading: boolean = true;
  step: number = 0;
  profile: Profile;
  reviewText: string;
  initBtnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('bid-create.continue'),
    }
  ];

  constructor(
    private profileService: ProfileService,
    private chdRef: ChangeDetectorRef,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.reviewText = this.translate.instant('MOVEMENTS.MANGOPAY_REVIEW');
    this.profileService.getProfile(this.user.username).subscribe(resp => {
      this.profile = resp;
      const idvStatus = resp.mangopayIdvSession?.status;
      if (idvStatus === 'VALIDATED') {
        this.loading = false;
        this.continue();
        return;
      }
      this.step = idvStatus === 'REVIEW' ? 2 : 1;
      this.loading = false;
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  continue() {
    this.continueEvent.emit();
    this.chdRef.detectChanges();
  }
}
